import { EntityType, NotesComponent, useParams } from "../../../utils/globalImports";

const ProposalFeeStageNotesComments: React.FC = () => {
   const { feeStageId } = useParams<{ feeStageId?: string }>(); // Get feeStageId from URL

  return (
    <NotesComponent
      resourceId={Number(feeStageId)}
      title="Fee Stage"
      entityTypeId={EntityType.FeeStage}
      entityId={Number(feeStageId)}
      searchbarText="Search for notes/comments"
    />
  );
};

export default ProposalFeeStageNotesComments;
